const state = {
  aboutUs: '',
  slogan: '',
  benefits: {
    topBenefits: [],
    standardBenefits: [],
  },
  inside: [],
  team: [],
  kpi: [],
  banner: '',
  socials: [],
  allBenefits: [],
  isPublished: false,
  publicProfile: {}
}

export default state
